export { default as ClarityConsent } from './Clarity';
